import { useState } from "react";
import { homeService } from "@miplatform/api";

export const usePlanCommunitiesViewModel = ({
  stateManager,
  accountId,
  debouncedSearch,
}) => {
  const [communities, setCommunities] = useState([]);

  const getCommunities = ({ top, skip } = {}) => {
    return stateManager.run(async () =>
      homeService.communities.getAll({
        sort: "name",
        filters: {
          builder: { id: { type: "guid", value: accountId } },
          name: { contains: debouncedSearch },
        },
        top,
        skip,
      })
    );
  };

  return {
    isLoading: stateManager.isBusy(),
    communities,
    setCommunities,
    getCommunities,
  };
};
